import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserDataService {
  /** username Updated behavior subject */
  usernameUpdated = new BehaviorSubject(false);
  /** username Updated observable */
  usernameUpdated$ = this.usernameUpdated.asObservable();

  /** user Image Updated behavior subject */
  userImageUpdated = new BehaviorSubject(false);
  /** user Image Updated observable */
  userImageUpdated$ = this.userImageUpdated.asObservable();
  /** firstName Updated behavior subject */
  firstNameUpdated = new BehaviorSubject(false);
  /** firstName Updated observable */
  firstNameUpdated$ = this.firstNameUpdated.asObservable();
  /** lastName Updated behavior subject */
  lastNameUpdated = new BehaviorSubject(false);
  /** lastName Updated observable */
  lastNameUpdated$ = this.lastNameUpdated.asObservable();
  /** title Display Updated behavior subject */
  titleDisplayUpdated = new BehaviorSubject(false);
  /** title Display Updated observable */
  titleDisplayUpdated$ = this.titleDisplayUpdated.asObservable();

	  /**
   * Get Title Display
   */
	  getTitleDisplay() {
		let titleDisplay;
		if (localStorage.getItem('firstName') && localStorage.getItem('lastName')) {
		  titleDisplay = localStorage.getItem('firstName')?.trim() + ' ' + localStorage.getItem('lastName')?.trim();
	
		} else {
		  titleDisplay = '';
	
		}
		return titleDisplay;
	  }
}
